<template>
  <router-view/>
</template>
<script>
export default {
  name: 'Administrators'
}
</script>
